<template>
  <div :data-upd="filter.selected"
       class="posr"
       :class="{'zitop': open}">
    <button
      v-on:click.prevent="toggle()"
      class="a-btn a-btn--border btn-filter-dark btn-filter btn-filter-select">
      {{copyLabel}}
      <span
        class="btn-filter-select__selected-value btn-filter-select__selected-value--seamless"
        v-show="selectedColors.length > 0">
        <span
          v-for="color in selectedColors"
          class="custom-checkbox custom-checkbox--color custom-checkbox--inline">
          <span
            :class="'custom-checkbox__color custom-checkbox__color--' + color">
          {{color}}
          </span>
        </span>
      </span>
      <i class="ico ico-angle-down"></i>
    </button><button
    class="btn btn-filter-select__reset-btn"
    v-if="selectedColors.length > 0" v-on:click.prevent="reset()">
    <span class="sr-only">Clear</span>
    <i class="icon icon-times"></i>
  </button>
    <div v-show="open"
         class="btn-filter-select__choices btn-filter-select__choices--white">
      <div
        v-for="item in filter.list"
        class="custom-checkbox custom-checkbox--color custom-checkbox--inline "
        :class="{'is-active': isChecked(item)}">
        <label :title="item.label">
          <input type="checkbox" :name="filter.key" :value="item.value" v-model="checkedItem" @change="change">
            <span :class="'custom-checkbox__color custom-checkbox__color--' + item.id"></span>
        </label>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .custom-checkbox__color:after {display: none;}
</style>

<script>
  export default {
    props: {
      filter: {
        type: Object,
        required: true
      },
      mobile: {
        type: Boolean,
        default: false
      },
      alreadyOpened: {
        type: Number,
        required: false
      }
    },
    data: function () {
      return {
        open: false,
        checkedItem: this.filter.selected,
        componentId: Math.random() * 10000
      }
    },
    watch: {
      alreadyOpened (id) {
        if (id !== this.componentId) {
          this.open = false
        }
      }
    },
    methods: {
      toggle: function () {
        this.open = !this.open

        if (this.open) {
          this.$emit('onOpen', this.componentId)
        }
      },
      isChecked: function (item) {
        return this.checkedItem.indexOf(item.value) !== -1
      },
      change: function () {
        this.$store.dispatch('setFilter', {
          key: this.filter.key,
          value: this.checkedItem
        })
      },
      reset: function () {
        this.checkedItem = []
        this.change()
      }
    },
    computed: {
      copyLabel: function () {
        return this.$store.getters.copy(this.filter.label)
      },
      selectedColors () {
        return this.$store.getters.selectedColorList
      }
    },
    mounted: function () {
      this.open = this.mobile
    },
    updated: function () {
      this.checkedItem = this.filter.selected
    }
  }
</script>

<style>
  .zitop {
    z-index: 220;
  }
</style>



// WEBPACK FOOTER //
// src/components/filter/FilterColor.vue